import React, { useRef, useEffect } from 'react';
import { Box } from '@mui/material';
import { HeroBanner } from '../../components';
import SEO from '../../components/SEO';
const HomePage = ({ setRefs }) => {
  const homeRef = useRef(null);

  useEffect(() => {
    setRefs({ home: homeRef });
  }, [setRefs]);

  return (
    <>
      <SEO
        title="Home"
        description="Sentinel – Real-time oversight and risk intelligence for algorithmic trading operations."
        keywords="sentinel, risk, monitoring, oversight, algorithmic trading"
      />
      <Box 
        ref={homeRef}
        id="home"
        sx={{ 
          backgroundColor: 'var(--neutral-white)',
          minHeight: '100vh',
          position: 'relative'
        }}
      >
        <HeroBanner />
    
        
        {/* Additional sections can be added here */}
        
      </Box>
    </>
  );
};

export default HomePage;
